<template>
   <div id="header" class="bg-white">
      <div class="iamBlock text-center"><span>i'm {{text}}</span></div>
      <div class="headerDiv">
         <div class="ml-4">
            <span :class="currentRouteName ==='mainPage' ? 'text-danger':''"><router-link to="/">Home</router-link></span>&nbsp;&nbsp;&nbsp;
            <span :class="currentRouteName ==='aboutMe' ? 'text-danger':''"><router-link to="/aboutMe">About Me</router-link></span>&nbsp;&nbsp;&nbsp;
            <span :class="currentRouteName ==='birthdate' ? 'text-danger':''"><router-link to="/project/birthdate">My Birthdate</router-link></span>
         </div>
         <div class="text-right mr-4">
            <a href="#" :class="lang === 'th'? 'text-danger' : ''" @click.prevent="changeLang('th')">TH</a> /
            <a href="#" :class="lang === 'en'? 'text-danger' : ''" @click.prevent="changeLang('en')">EN</a>
         </div>
      </div>
   </div>
</template>

<style scoped>

   .headerDiv {
      display: flex!important;
      justify-content:space-between!important;
   }

</style>

<script>
import {mapGetters} from 'vuex';
export default {
   data:function(){
      return {
         idx : 0,
         idt : 0,
         toWrite : [
            "pudthimad",
            "developer"
         ],
         text : ""
      }
   },
   computed : Object.assign({
      currentRouteName() {
        return this.$route.name;
      }
   },
      mapGetters(['lang'])
   ),
   methods : {
      changeLang (lang) {
         this.$store.dispatch('setLang',lang)
         this.$i18n.locale = lang
      }
   },
   mounted : function(){
      var self = this
      setInterval(function(){
         var idt = self.idt
         var idx = self.idx
         var toWrite = self.toWrite;
         if(idt>=toWrite.length){
            self.idt = 0
            idt = 0
         }
         var data = toWrite[idt]
         var length = data.length
         self.text= data.slice(0,idx)
         self.idx ++;
         if(idx > length) {
            self.idx = 0
            self.idt++
         }
      }, 220);
   }
}
</script>


// WEBPACK FOOTER //
// src/components/mainHeader.vue